import { createContext, useContext, useState, ReactNode } from "react";

export type Language = {
  code: string;
  name: string;
  dir: "ltr" | "rtl";
};

export const languages: Language[] = [
  { code: "en", name: "English (United States)", dir: "ltr" },
  { code: "ar", name: "العربية", dir: "rtl" },
];

type LanguageContextType = {
  currentLanguage: Language;
  setLanguage: (language: Language) => void;
};

const LanguageContext = createContext<LanguageContextType | undefined>(
  undefined
);

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [currentLanguage, setCurrentLanguage] = useState<Language>(
    languages[0]
  );

  const setLanguage = (language: Language) => {
    document.documentElement.dir = language.dir;
    document.documentElement.lang = language.code;
    setCurrentLanguage(language);
  };

  return (
    <LanguageContext.Provider value={{ currentLanguage, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
